import React from "react";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";

export type TrunkSelectOption = {
    value: any;
    label: string;
    disabled: boolean;
    inactive: boolean;
};

export function trunkRecordIsActive(item: {trunkIsActive?: boolean} | null | undefined): boolean {
    return item?.trunkIsActive !== false;
}

export function uniqueTrunkOptions(
    items: any[] | null | undefined,
    mapItem: (item: any) => {value: any; label: any} | null
): TrunkSelectOption[] {
    const byKey = new Map<string, TrunkSelectOption>();
    (items || []).forEach((item) => {
        const mapped = mapItem(item);
        if (!mapped || mapped.value == null || mapped.value === "") {
            return;
        }
        const key = String(mapped.value);
        const active = trunkRecordIsActive(item);
        const label = mapped.label == null || mapped.label === "" ? String(mapped.value) : String(mapped.label);
        const existing = byKey.get(key);
        if (!existing) {
            byKey.set(key, {value: mapped.value, label, disabled: !active, inactive: !active});
            return;
        }
        if (active) {
            existing.disabled = false;
            existing.inactive = false;
        }
        if ((existing.label === key || existing.label === "") && label !== key) {
            existing.label = label;
        }
    });
    return Array.from(byKey.values());
}

export function keepCurrentTrunkSelectable(options: TrunkSelectOption[], currentId: any): TrunkSelectOption[] {
    if (currentId == null) {
        return options;
    }
    return options.map((option) =>
        String(option.value) === String(currentId) ? {...option, disabled: false} : option
    );
}

export function isTrunkIdInactive(items: any[] | null | undefined, trunkId: any): boolean {
    if (trunkId == null || !Array.isArray(items)) {
        return false;
    }
    const rows = items.filter((item) => String(item?.sofiaTrunkId ?? item?.trunkId) === String(trunkId));
    if (!rows.length) {
        return false;
    }
    return rows.every((item) => item?.trunkIsActive === false);
}

export function assignedTrunkIsInactive(record: {trunkIsActive?: boolean | null} | null | undefined): boolean {
    return record?.trunkIsActive === false;
}

export function assignedPhoneIsInactive(record: {isActive?: boolean | null} | null | undefined): boolean {
    return record?.isActive === false;
}

export function trunkInactiveLabel(label: any): string {
    return label == null ? "" : String(label);
}

export function TrunkInactiveIcon() {
    return (
        <i
            className="pi pi-ban trunk-inactive-icon"
            title="Неактивний"
            aria-label="Неактивний"
        />
    );
}

export function TrunkNameField({value, inactive, className}: {value: string; inactive?: boolean; className?: string}) {
    return (
        <div className="trunk-name-field">
            <InputText
                disabled
                value={value}
                className={classNames("w-full", className)}
                style={inactive ? {paddingRight: "2.25rem"} : undefined}
            />
            {inactive ? <TrunkInactiveIcon /> : null}
        </div>
    );
}

export function trunkSelectItemTemplate(option: TrunkSelectOption) {
    if (!option) {
        return null;
    }
    return (
        <span className={classNames("flex align-items-center justify-content-between gap-3 w-full", {"opacity-60": option.inactive})}>
            <span>{option.label}</span>
            {option.inactive ? <TrunkInactiveIcon /> : null}
        </span>
    );
}

export function trunkSelectValueTemplate(option: TrunkSelectOption | null, props?: {placeholder?: string}) {
    return (
        <span className={classNames("trunk-select-value", {"opacity-70": option?.inactive})}>
            <span>{option?.label || props?.placeholder || "\u00a0"}</span>
            {option?.inactive ? <TrunkInactiveIcon /> : null}
        </span>
    );
}

export function TrunkStatusPill({active}: {active?: boolean}) {
    return (
        <span className={classNames("trunk-status-pill", active ? "trunk-status-pill--active" : "trunk-status-pill--inactive")}>
            {active ? "ACTIVE" : "INACTIVE"}
        </span>
    );
}
